import React, { useContext } from 'react';
import { Button, Tooltip, IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ArrowLeft from '../../icons/arrowLeft2.png';
import { ROUTES } from '../../../const';
import { ShopContext } from '../../../contexts/ShopContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const styles = {
  wrapper: {
    height: 'fit-content',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  img: {
    height: '24px',
    width: '24px',
  },
  headerWrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  head: {
    fontSize: '18px',
    fontWeight: '600',
  },
};

const btnStyle = {
  height: '44px',
  width: '44px',
  minWidth: '0px',
  backgroundColor: '#fff',
  border: '1px solid #F9F9F9',
  borderRadius: '14px',
  boxShadow: ' 0px 4px 24px 0px #B0B0B040',
};

function PageHeader({
  title,
  showBackBtn = true,
  backToHome = false,
  color = '#1e1e1e',
  showBorder = true,
  showContact = false,
}) {
  const history = useHistory();
  const { shop } = useContext(ShopContext);

  const container = {
    height: '70px',
    width: '100%',
    backgroundColor: 'transparent',
    borderBottom: showBorder ? '1px solid #F9F9F9' : 'none',
    boxShadow: showBorder ? '0px 2px 5px 0px #00000008' : 'none',
    display: 'flex',
    alignItems: 'end',
    padding: '10px 15px',
  };

  const handleBackBtn = () => {
    if (backToHome) {
      history.push(ROUTES.SHOP_HOME.replace(':shopId', shop.shopId));
      return;
    }
    history.goBack();
  };

  return (
    <div style={container}>
      <div style={styles.wrapper}>
        {showBackBtn && (
          <Button variant="contained" style={btnStyle} onClick={handleBackBtn}>
            <img src={ArrowLeft} style={styles.img} alt="" />
          </Button>
        )}
        <div style={styles.headerWrapper}>
          <span style={{ ...styles.head, color }}>{title}</span>
        </div>
        {showContact && (
          <Tooltip title="More">
            <IconButton onClick={() => history.push(ROUTES.CONTACT_US.replace(':shopId', shop.shopId))}>
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
